import type { CareOrder, TimestampField } from '@talos/kyoko';

export type CareOrderTimestampField = keyof Pick<CareOrder, 'Timestamp' | 'SubmitTime'>;

export const careOrderTimestampFields: TimestampField<CareOrderTimestampField>[] = [
  {
    Name: 'Timestamp',
    DisplayName: 'Timestamp',
    Description:
      'Performs date range filtering based on the Timestamp property of the Care Order. Any time an action is performed on a Care Order, the Timestamp is updated.',
    default: true,
  },
  {
    Name: 'SubmitTime',
    DisplayName: 'Submit Time',
    Description:
      'Performs date range filtering based on the Submit Time property of the Care Order. The Submit Time is the time of Care Order submission, and is never updated.',
    default: false,
  },
];

export function getDefaultCareOrderTimestampField(): CareOrderTimestampField | undefined {
  return careOrderTimestampFields.find(timestampField => timestampField.default)?.Name;
}
